import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { History, Loader2 } from "lucide-react";

export const fmtDateTime = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const EntityHistory = ({ entityId, model, testid = "entity-history" }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ["activity-entity", entityId, model],
    queryFn: async () => (await api.get("/activity/entity", { params: { entity_id: entityId, model } })).data,
  });
  return (
    <div className="rounded-md border border-border/60 p-4" data-testid={testid}>
      <p className="mb-2 flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-muted-foreground">
        <History className="h-3.5 w-3.5 text-primary" />Storico modifiche
      </p>
      {isLoading ? <Loader2 className="h-4 w-4 animate-spin text-primary" /> : data.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid={`${testid}-empty`}>Nessuna modifica registrata</p>
      ) : (
        <ul className="max-h-56 space-y-1.5 overflow-auto text-xs">
          {data.map((a) => (
            <li key={a.id} className="flex justify-between gap-3 border-b border-border/40 pb-1.5 last:border-0" data-testid={`${testid}-row`}>
              <span><span className="font-medium text-foreground">{a.user_name}</span> · {a.label}</span>
              <span className="shrink-0 font-mono-erp text-muted-foreground">{fmtDateTime(a.at)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
